import React from "react";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import colors from "../../../constants/colors";
import { UserManagementProductResponse } from "../../../models/Administration";
import { camelToTitleCase } from "../../../utils";
import { Typography } from "@material-ui/core";

interface UserProductDisplayCardProps {
	//The current product to display on this card.
	product: UserManagementProductResponse;
	//Indicates whether the product is selected.
	selected: boolean;
	//Indicates whether the product is enabled for the current user.
	enabled: boolean;
	//Indicates whether the product has been edited this session.
	edited: boolean;
	//Method passes the cards product name to tell the parent componet which product is currently selected.
	setSelectedProduct: (productName: string) => void;
}

const useStyles = makeStyles((theme) => ({
	card: {
		borderRadius: theme.spacing(0.5),
		width: "100%",
	},
	cardContent: {
		padding: theme.spacing(1),
	},
}));

/**
 * Takes in a pow product and multiple booleans indicating
 * what state the current product card is in.
 * @param props
 */
export const UserProductDisplayCard = (props: UserProductDisplayCardProps) => {
	const classes = useStyles();

	return (
		<Card
			className={classes.card}
			style={{ backgroundColor: props.selected ? colors.gray300 : colors.white }}
			onClick={() => props.setSelectedProduct(props.product.productName)}
		>
			<div className={classes.cardContent}>
				<div>
					<Typography
						style={{
							display: "flex",
							fontWeight: props.enabled ? "bold" : "normal",
							fontStyle: props.edited ? "italic" : "normal",
							justifyContent: "space-between",
							alignItems: "center",
							marginBottom: 6,
						}}
					>
						{camelToTitleCase(props.product.productName)} {props.edited ? "*" : ""}
					</Typography>
				</div>
				<div>
					<Typography variant={"caption"}>{props.product.productDescription}</Typography>
				</div>
			</div>
		</Card>
	);
};
